import { api } from '@/shared/api/client';
import type { PostQuizzesAnswerResponse } from '../model/dto';

interface PostQuizzesAnswerProps {
  id: string;
  quiz_id: string;
  answer_bool: boolean | null;
}

export const postQuizzesAnswer = async (params: PostQuizzesAnswerProps) => {
  const { id, quiz_id, ...payload } = params;
  const { data } = await api.post<PostQuizzesAnswerResponse>(
    `/contents/${id}/quizzes/${quiz_id}/answer/`,
    payload
  );
  return data;
};
